import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/topic/tag.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-d67ab426"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "head-view"
};
var _hoisted_2 = {
  class: "content-wrap"
};
var _hoisted_3 = {
  class: "name"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});

var _hoisted_5 = {
  key: 0,
  class: "desc"
};
var _hoisted_6 = {
  class: "count"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 人参与 ");

var _hoisted_8 = {
  class: "bottom-wrap"
};
import composition from '@/composition';
import ua from '@/utils/platform';
export default {
  props: {
    model: Object,
    categoryModel: Object
  },
  setup: function setup(__props) {
    var props = __props; // import autoHidebar from '@/components/common/auto-hide-bar.vue'

    var _composition = composition(),
        ref = _composition.ref,
        request = _composition.request,
        computed = _composition.computed,
        openWebPage = _composition.openWebPage,
        loginHandle = _composition.loginHandle,
        navigateToWechatMiniProgram = _composition.navigateToWechatMiniProgram;

    var go2233 = ref(null);

    var handle_go2233 = function handle_go2233() {
      if (go2233.value) {
        go2233.value.commonClick2233();
      }
    }; // 关注状态


    var subscribeState = ref(false); // 参与人数

    var joinCount = computed(function () {
      return Number(props.model.commentCount) + Number(props.model.fansCount) + Number(props.model.postCount);
    }); // 打开频道

    var openChannel = function openChannel() {
      openWebPage('channel/index.html', props.categoryModel.id);
    }; // 关注


    function follow(state) {
      if (ua.isMini) {
        navigateToWechatMiniProgram();
      } else {
        loginHandle().then(function () {
          _Toast.loading({
            message: '操作中...',
            duration: 0,
            forbidClick: true
          });

          request.followTag(props.model.id, state).then(function () {
            _Toast.success('操作成功');

            subscribeState.value = state;

            if (state == true) {
              _poc_follow(props.model.name, props.model.id);
            }
          }).catch(function () {
            _Toast.fail('操作失败');
          });
        });
      }
    }

    function _poc_follow(title, id) {
      // [埋点] 社区页访问
      var _poc_event_params = {
        topic_id: id,
        topic_name: title
      }; // eslint-disable-next-line no-undef

      qaplus.event.record('fsplusmp_community_topic_follow', 2101, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record('fsplusmp_community_topic_follow', _poc_event_params);
    }

    return function (_ctx, _cache) {
      var _component_van_image = _resolveComponent("van-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_image, {
        class: "bg-img",
        src: __props.model.background,
        fit: "cover"
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(__props.model.name), 1)]), __props.model.description && __props.model.description.length > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.model.description), 1)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_unref(joinCount)), 1), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: "name",
        onClick: openChannel
      }, _toDisplayString(__props.categoryModel.name), 1), _unref(ua).isFsPlus || _unref(ua).isMini ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [(subscribeState.value == null ? __props.model.subscribeState : subscribeState.value) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "followed-btn",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return follow(false);
        })
      })) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "follow-btn",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return follow(true);
        })
      }))], 64)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "follow-btn",
        onClick: handle_go2233
      }))])])]);
    };
  }
};